export default {"src":"/_next/static/media/fountain.9aa20cec.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};